export interface SubscriptionPlan {
  value: string;
  name: string;
  maxTrainees: number;
}

export const subscriptionPlans: SubscriptionPlan[] = [
  {
    value: "STARTER_10",
    name: "מסלול מתחיל עד 10 מתאמנים",
    maxTrainees: 10
  },
  {
    value: "BASIC_25",
    name: "מסלול בסיס עד 25 מתאמנים",
    maxTrainees: 25
  },
  {
    value: "ADVANCED_50",
    name: "מסלול מתקדם עד 50 מתאמנים",
    maxTrainees: 50
  },
  {
    value: "PROFESSIONAL_100",
    name: "מסלול מקצוען עד 100 מתאמנים",
    maxTrainees: 100
  },
  {
    value: "PREMIUM_200",
    name: "מסלול פרימיום עד 200 מתאמנים",
    maxTrainees: 200
  },
  {
    value: "EDGE_1000",
    name: "מסלול קצה עד 1000 מתאמנים",
    maxTrainees: 1000
  }
];

export const getSubscriptionPlanName = (value: string): string => {
  const plan = subscriptionPlans.find(p => p.value === value);
  return plan ? plan.name : "לא הוגדר";
};

export const getMaxTrainees = (value: string): number | null => {
  const plan = subscriptionPlans.find(p => p.value === value);
  return plan ? plan.maxTrainees : null;
};

/**
 * A company is over its subscription plan only when its ACTIVE trainee count exceeds the plan
 * limit. Disabled trainees don't consume a seat, so `activeTraineeCount` must be the active count
 * (`activeTraineeCount` / `numberOfActiveTrainees` from the server) — never the total.
 * A company with no plan is unlimited.
 */
export const isOverLimit = (subscriptionPlan: string, activeTraineeCount: number): boolean => {
  const maxTrainees = getMaxTrainees(subscriptionPlan);
  if (maxTrainees === null) return false;
  return activeTraineeCount > maxTrainees;
};
